/**
 * Created by jzj on 2018/10/16.
 */
'use strict'

export const defaultPlatform = 'Ethereum'
export const platforms = [
  {
    name: 'Ethereum',
    key: 'Ethereum',
    enable: true
  },
  {
    name: 'Steem',
    key: 'Steem',
    enable: false
  },
  {
    name: 'EOS',
    key: 'EOS',
    enable: false
  }
]
export const urls = {
  blog: 'https://www.dappchaser.com/',
  submitForm: 'https://docs.google.com/forms/d/e/1FAIpQLSeSDCMVaCM3oWonvawUvuUtY4gjzZnvcAzkC12_Zs4-Xy5lTg/viewform'
}
const apis = {
  local: "http://localhost:9000",
  ip: "http://47.244.25.246/api/v1",
  url: "https://data.dappchaser.com/api/v1",
}
const development = apis.url
const production = apis.url
export const api = PRODUCTION ? production : development



// WEBPACK FOOTER //
// ./src/const.js